import React, { useState } from "react";
import { useCountdown } from "../hooks/useCountdown";
import HeaderImage from "../assets/images/codice_contatto_totem_sfondo.png";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Modal } from 'rsuite';
import { useIntl } from "react-intl";
import { CardPatientTotem } from "./CardPatientTotem";
import moment from 'moment';
import { FiPlus } from "react-icons/fi";
import { SemiDonutChart } from "./SemiDonutChart";

export const BodyMonitoraggioTotem = ({ nedocsValue, history, firstEncounter, currentTime, description, generalStatus, callbackOnRenewSession }) => {

    const intl = useIntl();
    const [sessionExpiringModalVisible, setSessionExpiringModalVisible] = useState(false);

    const { reset: resetSession, timeLeft } = useCountdown(
        60,
        () => {
            setSessionExpiringModalVisible(false);
            history.push("/totem");
        },
        15,
        () => {
            setSessionExpiringModalVisible(true);
        }
    );

    const onRenewSession = () => {
        resetSession();
        setSessionExpiringModalVisible(false);
        callbackOnRenewSession();
    };

    const textStyleNormal = {
        fontSize: "150%",
        color: "#fff",
    };

    const textStyleSmall = {
        fontSize: "100%",
        color: "#fff",
    };

    return (
        <React.Fragment>
            <Container
                fluid={"true"}
                style={{
                    backgroundImage: `url(${HeaderImage})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100%",
                    backgroundColor: "#F5F5F5",
                    minHeight: '100vh'
                }}
            >
                <Row>
                    <Col md={3}>
                        <Button className="m-4 w-100 btn-lg" style={{ background: "rgba(254,254,254, 0.5)", border: "none" }} onClick={() => history.push("/totem")} >
                            <span style={textStyleNormal}><b>{intl.formatMessage({ id: "monitoraggioPageTotem.exit" })}</b></span>
                        </Button>
                    </Col>
                    <Col></Col>
                    <Col md={3} style={{ textAlign: "end" }}>
                        <span className="m-5" style={textStyleNormal}>{moment().format("hh:mm")}</span>
                    </Col>
                </Row>
                {!firstEncounter ?

                    <Row className="align-items-center justify-content-center">
                        <Col md={3}></Col>
                        <Col md={6} className="text-center">
                            <Row>
                                <Col className="font-weight-bold" style={{ fontSize: "250%", textAlign: "center", color: "#fff" }}>
                                    {intl.formatMessage({ id: "monitoraggioPageTotem.patientStatus" })}
                                </Col>
                            </Row>
                            <Row>
                                <Col style={textStyleNormal}>
                                    {intl.formatMessage({ id: "monitoraggioPageTotem.code" })}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Row className="m-3">
                                        <Col></Col>
                                        <Col></Col>
                                        <Col className="align-self-end" style={textStyleSmall}>
                                            <b>aggiornato {currentTime} min. fa</b>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={3} className="text-center">
                            <Row>
                                <Col style={textStyleNormal}>
                                    {intl.formatMessage({ id: "homePage.statusProntoSoccorso" })}
                                </Col>
                            </Row>
                            <Row className="align-items-center justify-content-center">
                                <div style={{
                                    marginTop: "5%",

                                }}>
                                    <Row
                                        style={{
                                            fontSize: "100%",
                                            alignItems: "center",
                                            marginBottom: "1em"
                                        }}>
                                        {/* COMPONENTE PER INDICE AFFOLLAMENTO */}
                                        <Col lg={3}>
                                            <div style={{ width: "10em" }}>
                                                <SemiDonutChart percentage={nedocsValue > 0 ? nedocsValue : 0} />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Row>
                            <Row>
                                <Col style={textStyleSmall}>
                                    {intl.formatMessage({ id: "monitoraggioPageTotem.index" })}
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    :

                    <Row className="align-items-center justify-content-center">
                        <Col md={3}></Col>
                        <Col md={6} className="text-center">
                            <Row>
                                <Col className="font-weight-bold" style={{ fontSize: "250%", textAlign: "center", color: "#fff" }}>
                                    {intl.formatMessage({ id: "monitoraggioPageTotem.patientStatus" })}
                                </Col>
                            </Row>
                            <Row>
                                {description && <Col style={textStyleNormal}>
                                    {description}
                                </Col>}
                            </Row>
                            <Row>
                                <Col>
                                    <Row className="m-3">
                                        <Col></Col>
                                        <Card className="border-0 border-card d-block" style={{ background: "rgba(254, 254, 254, 0.5)" }}>
                                            <Col style={textStyleSmall} >
                                                {generalStatus}
                                            </Col>
                                        </Card>
                                        <Col className="align-self-end" style={textStyleSmall}>
                                            <b>aggiornato {currentTime} min. fa</b>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={3} className="text-center">
                            <Row>
                                <Col style={textStyleNormal}>
                                    {intl.formatMessage({ id: "homePage.statusProntoSoccorso" })}
                                </Col>
                            </Row>
                            <Row className="align-items-center justify-content-center">
                                <div style={{
                                    marginTop: "5%",

                                }}>
                                    <Row
                                        style={{
                                            fontSize: "100%",
                                            alignItems: "center",
                                            marginBottom: "1em"
                                        }}>
                                        {/* COMPONENTE PER INDICE AFFOLLAMENTO */}
                                        <Col lg={3}>
                                            <div style={{ width: "10em" }}>
                                                <SemiDonutChart percentage={nedocsValue > 0 ? nedocsValue : 0} />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Row>
                            <Row>
                                <Col style={textStyleSmall}>
                                    {intl.formatMessage({ id: "monitoraggioPageTotem.index" })}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                }
                <Container fluid={"true"}>
                    <Row className="align-items-center justify-content-center">
                        <Col lg={6}>
                            <CardPatientTotem encounter={firstEncounter} />
                        </Col>
                    </Row>
                    <Row className="align-items-center justify-content-center">
                        <Col className="m-5" lg={6}>
                            <Card className="border-0 border-card d-block">
                                <Button
                                    className="container-fluid font-weight-bold"
                                    variant={"outline-danger"}
                                    style={{ display: "inherit", height: "80px", fontSize: "100%", textTransform: "uppercase", borderRadius: "10px" }}
                                    onClick={() => history.goBack()}>
                                    <FiPlus style={{ fontSize: "120%", verticalAlign: "text-bottom" }} />
                                    <span>{intl.formatMessage({ id: "monitoraggioPageTotem.altroPaziente" })}</span>
                                </Button>
                            </Card>
                        </Col>
                    </Row>
                </Container>


                <Modal
                    backdropClassName="rsuite-backdrop"
                    show={sessionExpiringModalVisible}
                    onHide={() => setSessionExpiringModalVisible(false)}
                >
                    <Modal.Header>
                        <Modal.Title>
                            {intl.formatMessage({ id: 'monitoraggioPazientePage.scadenzaSessione' })}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {intl.formatMessage(
                            { id: 'monitoraggioPazientePage.descrizioneSessioneInScadenza' },
                            { time: timeLeft }
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="border-0"
                            style={{ backgroundColor: '#092451' }}
                            onClick={onRenewSession}
                        >
                            {
                                intl.formatMessage({ id: 'monitoraggioPazientePage.rinnovaSessione' })}
                        </Button>
                    </Modal.Footer>
                </Modal>

            </Container>
        </React.Fragment>
    )
}